import {
  Component,
  effect,
  inject,
  Renderer2,
  HostListener,
  ElementRef,
  Input,
  ChangeDetectorRef,
  NgZone,
  ViewChild,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { SharedSignalsService } from '../../services/shared-signals.service';
import { TranslationService } from '../../services/translation.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SessionVariable } from '../../enum/session-variable';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { FormControl } from '@angular/forms';
import { Dropdown } from 'primeng/dropdown';
import { Subscription } from 'rxjs';
import { EnvService } from '../../../env.service';

@Component({
  selector: 'taly-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss'],
  providers: [ConfirmationService],
  standalone: false,
})
export class SiteHeaderComponent implements OnInit, OnDestroy {
  transferSignal = inject(SharedSignalsService);
  public translationService = inject(TranslationService);
  private storageService = inject(LocalStorageService);
  public envService = inject(EnvService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private confirmationService = inject(ConfirmationService);
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private cdRef = inject(ChangeDetectorRef);
  private ngZone = inject(NgZone);

  toggleCurrentLanguage: boolean = false;
  isHeader: boolean = false;
  textDirection!: string;
  heaerItems: any[] = [];
  isMenuOpen: boolean = false;
  isWindowResize: boolean = false;
  isDarkHeader: boolean = false;
  isActive!: number | null;
  routeNameToCompare!: string;
  isDropDownActive: boolean = false;
  @Input() home!: string;
  currentRoute!: string;
  isDropdownOpen: boolean = false;
  menuCtrl = new FormControl();
  dropdownOpen: boolean = false;
  isGreyHeader: boolean = false;
  isHovered: boolean = false;
  routerSub!: Subscription;
  private popStateHandler: (() => void) | null = null;
  appLink: string;

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
      this.isDarkHeader = this.transferSignal.darkHeader();
      this.isGreyHeader = this.transferSignal.darkHeader();
      this.heaerItems = [];
      setTimeout(() => {
        this.ngZone.run(() => {
          this.setHeaderItem();
          this.cdRef.detectChanges();
        });
      }, 100);
    });
    const osInfo = this.transferSignal?.userAgentType();
    if (osInfo == 'iOS') {
      this.appLink = this.envService.appIOSURL;
    } else {
      this.appLink = this.envService.appAndroidURL;
    }
  }

  @ViewChild('dropdown') dropdown!: Dropdown;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const headerElement = document.querySelector('.site-header');
    if (scrollPosition >= 70) {
      this.renderer.addClass(headerElement, 'header-bg-blue');
    } else {
      this.renderer.removeClass(headerElement, 'header-bg-blue');
    }
  }

  ngOnInit(): void {
    const headerElement = document.querySelector('.site-header');
    this.menuCtrl?.patchValue(location?.pathname);
    this.updateHeaderBg(headerElement, location.pathname);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        this.updateHeaderClass();
        this.updateHeaderBg(headerElement, event.urlAfterRedirects);
        const isHomeRoute = event.url === '/';
        const isShopRoute = event.url === '/partner';
        if (isHomeRoute) {
          this.renderer.addClass(headerElement, 'bg-blue');
          this.renderer.removeClass(headerElement, 'bg-grey');
        } else {
          this.renderer.removeClass(headerElement, 'bg-blue');
          this.renderer.addClass(headerElement, 'bg-grey');
        }
        if (isShopRoute) {
          this.renderer.removeClass(headerElement, 'bg-grey');
        }
      }
    });

    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.dropdownOpen = false;
        this.currentRoute = event.url;
        const isHomeRoute = event.url === '/';
        const headerElement = document.querySelector('.site-header');
        if (isHomeRoute) {
          this.renderer.addClass(headerElement, 'bg-blue');
        }
      }
    });

    const storedLang = (this.storageService.getItem(SessionVariable.LANGUAGE) as string) || 'en-US';
    this.toggleCurrentLanguage = storedLang === 'ar-KW';
    this.transferSignal.setTextDirection(storedLang === 'ar-KW' ? 'rtl' : 'ltr');
    this.translationService.switchLanguage(storedLang);
    // Keep a reference so ngOnDestroy can remove it; an anonymous listener leaked on every create.
    this.popStateHandler = () => this.updateHeaderBg(headerElement, location.pathname);
    window.addEventListener('popstate', this.popStateHandler);
  }

  updateHeaderBg(headerElement: Element | null, path: string) {
    if (!headerElement) return;
    if (path === '/') {
      this.renderer.addClass(headerElement, 'bg-blue');
      this.renderer.removeClass(headerElement, 'bg-grey');
    } else {
      this.renderer.removeClass(headerElement, 'bg-blue');
      this.renderer.addClass(headerElement, 'bg-grey');
    }
    if (path === '/partner') {
      this.renderer.removeClass(headerElement, 'bg-grey');
    }
  }

  setHeaderItem() {
    this.heaerItems = [
      // {
      //   label: this.translationService.getLabelValue('SITE_HEADER.SHOPS'),
      //   link: '/shops'
      // },
      {
        children: [
          {
            label: this.translationService.getLabelValue('SITE_HEADER.LEARN_MORE'),
            link: '/partner',
          },
          {
            label: this.translationService.getLabelValue('SITE_HEADER.SIGNUP_FOR'),
            link: '/partner/sign-up',
          },
          {
            label: this.translationService.getLabelValue('SITE_HEADER.SIGNUP_PARTNERS'),
            link: this.envService.MerchantURL,
            target: '_blank',
          },
          {
            label: this.translationService.getLabelValue('SITE_HEADER.DEVELOPERS'),
            link: this.envService.DocsURL,
            target: '_blank',
          },
        ],
      },
      {
        label: this.translationService.getLabelValue('SITE_HEADER.FAQ'),
        link: this.isGreyHeader ? '/faq-partner' : '/faq-shopper',
      },
      {
        label: this.translationService.getLabelValue('SITE_HEADER.DOWNLOAD'),
        type: 'download',
      },
    ];

    // Patch first dropdown item
    const dropdownMenu = this.heaerItems.find((item) => item.children)?.children?.[0];
    if (dropdownMenu?.link) {
      this.menuCtrl.patchValue(dropdownMenu.link);
    }
  }

  toggleText() {
    this.toggleCurrentLanguage = !this.toggleCurrentLanguage;
    const currentLanguage = this.toggleCurrentLanguage ? 'ar-KW' : 'en-US';
    this.transferSignal.setTextDirection(currentLanguage === 'ar-KW' ? 'rtl' : 'ltr');
    this.storageService.setItem(SessionVariable.LANGUAGE, currentLanguage);
    this.translationService.switchLanguage(currentLanguage);
    this.cdRef.detectChanges();
  }

  openOnHover(dropdown: Dropdown) {
    dropdown.show();
    this.dropdownOpen = true;
  }

  closeOnLeave(dropdown: Dropdown) {
    dropdown.hide();
    this.dropdownOpen = false;
  }

  navRedirection(data: any, index: any) {
    this.isMenuOpen = false;
    if (data?.type === 'download') {
      this.appDownloadPopup();
      return;
    }
    this.menuCtrl?.patchValue(data?.link);
    this.isActive = index;
    if (data?.target) {
      window.open(data?.link, '_blank');
    } else {
      this.router.navigate([data?.link], { relativeTo: this.activatedRoute });
    }
  }

  updateHeaderClass(): void {
    // const headerElement = document.querySelector('.site-header');
    if (this.currentRoute === '/') {
      this.isActive = null;
    }
  }

  appDownloadPopup() {
    this.confirmationService.confirm({
      accept: () => {},
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            break;
          case ConfirmEventType.CANCEL:
            break;
        }
      },
    });
  }

  getDarkSrc() {
    // if (this.isHovered && (this.isDarkHeader || this.isGreyHeader)) {
    //   return 'assets/images/hover-lang-logo.svg';
    // }
    // if (this.isDarkHeader || this.isGreyHeader) {
    //   return 'assets/images/dark-header-lang-logo.svg';
    // }
    // return 'assets/images/blue-lang.svg';
  }

  getDarkMobSrc() {
    // if (this.isHovered && (this.isDarkHeader || this.isGreyHeader)) {
    //   return 'assets/images/hover-lang-logo.svg';
    // }
    // if (this.isDarkHeader || this.isGreyHeader) {
    //   return 'assets/images/dark-header-lang-logo.svg';
    // }
    // return 'assets/images/lang-blue-light.svg';
  }

  getgreySrc() {
    // if (this.isHovered && this.isGreyHeader) {
    //   return 'assets/images/hover-lang-logo.svg';
    // }
    // return 'assets/images/dark-header-lang-logo.svg';
  }
  detectOS() {
    window.open(this.appLink, '_blank');
  }
  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }

    if (this.popStateHandler) {
      window.removeEventListener('popstate', this.popStateHandler);
      this.popStateHandler = null;
    }
  }
}
